import { render, staticRenderFns } from "./DSChangePayment.vue?vue&type=template&id=b05d681a&"
import script from "./DSChangePayment.vue?vue&type=script&lang=js&"
export * from "./DSChangePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports